export enum TreatmentFileGroups {
  ArcGroup = 11,
  WaxGroup = 29,
  DentureGroup = 31,
  FullArchScans = 33,
  TissueScans = 24,
  SmilingPictures = 15,
}
